import type { SurveyModel } from 'survey-core';
import { create } from 'zustand';
import { createSurveyModel } from '../../Onboarding/shared/infra/useGetSurveys';

export type CheckInSurveyState = {
  checkInSurvey: SurveyModel | null;
  checkInSurveyAnswers: Record<string, string | number>;
  setCheckInSurveyFromString: (checkInSurveyString: string) => void;
  setCheckInSurveyAnswers: (answer: Record<string, string | number>) => void;
};

export const useCheckInSurveyStore = create<CheckInSurveyState>()((set) => ({
  checkInSurvey: null,
  checkInSurveyAnswers: {},
  setCheckInSurveyFromString: (checkInSurveyString) => {
    const model = createSurveyModel(checkInSurveyString);
    set({ checkInSurvey: model });
  },
  setCheckInSurveyAnswers: (answers) => set({ checkInSurveyAnswers: answers }),
}));
